import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { formatPercentage } from '../../../utils/format/currency';

interface RateDifferenceProps {
  officialRate: number;
  parallelRate: number;
}

export function RateDifference({ officialRate, parallelRate }: RateDifferenceProps) {
  const difference = parallelRate - officialRate;
  const percentageDiff = (difference / officialRate) * 100;
  const isHigher = difference > 0;

  return (
    <div className="mt-4 p-4 bg-gradient-to-r from-gray-50 to-gray-100 rounded-lg border border-gray-200">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          {isHigher ? (
            <TrendingUp className="h-4 w-4 text-red-600" />
          ) : (
            <TrendingDown className="h-4 w-4 text-green-600" />
          )}
          <span className="text-sm font-medium text-gray-700">Rate Spread</span>
        </div>
        <div className="text-right">
          <p className="text-lg font-bold">
            ₦{Math.abs(difference).toFixed(2)}
          </p>
          <p className={`text-sm font-medium ${isHigher ? 'text-red-600' : 'text-green-600'}`}>
            {formatPercentage(Math.abs(percentageDiff))} {isHigher ? 'premium' : 'discount'}
          </p>
        </div>
      </div>
      <p className="text-xs text-gray-600 mt-2">
        The parallel market rate is {isHigher ? 'higher' : 'lower'} than the CBN official rate
      </p>
    </div>
  );
}